import { useDispatch } from "react-redux";

import {
  getOptionsData,
  getListData,
  setDownloadData,
  getDealsData,
  getProductsData,
  getBrandsData,
  getCurrenciesData,
  getPlatformsData,
  getColumnsData,
  getFiltersFieldData,
  clearDownload,
  clearListState,
  clearColumnsState,
  reset,
} from "./index";

export const useSubAffiliateReportV2 = () => {
  const dispatch = useDispatch();

  const getOptions = (data: any) => dispatch(getOptionsData(data));
  const getColumns = (data: any) => dispatch(getColumnsData(data));
  const getList = (data: any) => dispatch(getListData(data));
  const getProducts = (data: any) => dispatch(getProductsData(data));
  const getBrands = (data: any) => dispatch(getBrandsData(data));
  const getCurrencies = (data: any) => dispatch(getCurrenciesData(data));
  const getPlatforms = (data: any) => dispatch(getPlatformsData(data));
  const getDeals = () => dispatch(getDealsData());
  const setDownload = (data: any) => dispatch(setDownloadData(data));
  const getFiltersField = (data: any) => dispatch(getFiltersFieldData(data));

  const clearListData = () => dispatch(clearListState());
  const resetState = () => dispatch(reset());
  const clearDownloadState = () => dispatch(clearDownload());
  const clearColumns = () => dispatch(clearColumnsState());

  return {
    getOptions,
    getList,
    setDownload,
    clearDownloadState,
    clearListData,
    resetState,
    getDeals,
    getProducts,
    getBrands,
    getCurrencies,
    getPlatforms,
    getColumns,
    clearColumns,
    getFiltersField,
  }
}
